// Set up click handlers for scrolling to different sections in the page.
function scrollToElementOnClick(triggerSelector, destinationSelector) {
  let triggers = document.querySelectorAll(triggerSelector);

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function(event) {
      event.preventDefault();
      $('html, body').animate({
        scrollTop: $(destinationSelector).offset().top - 100
      }, 500);
    });
  });
}

scrollToElementOnClick('.view-plan-comparison[data-platform="shopify"]', '.plan-comparison[data-platform="shopify"]');
scrollToElementOnClick('.view-plan-comparison[data-platform="bigcommerce"]', '.plan-comparison[data-platform="bigcommerce"]');
scrollToElementOnClick('.view-plan-comparison[data-platform="wix"]', '.plan-comparison[data-platform="wix"]');
scrollToElementOnClick('.view-faqs', '.faqs');
